/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AcceptContractOfferMutationVariables = Exact<{
  contractId: string;
}>;


export type AcceptContractOfferMutation = { acceptContractOffer: { contractId: string } };


export const AcceptContractOfferDocument = /*#__PURE__*/ gql`
    mutation AcceptContractOffer($contractId: uuid!) {
  acceptContractOffer(contractId: $contractId) {
    contractId
  }
}
    `;
export type AcceptContractOfferMutationFn = Apollo.MutationFunction<AcceptContractOfferMutation, AcceptContractOfferMutationVariables>;

/**
 * __useAcceptContractOfferMutation__
 *
 * To run a mutation, you first call `useAcceptContractOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptContractOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptContractOfferMutation, { data, loading, error }] = useAcceptContractOfferMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useAcceptContractOfferMutation(baseOptions?: Apollo.MutationHookOptions<AcceptContractOfferMutation, AcceptContractOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptContractOfferMutation, AcceptContractOfferMutationVariables>(AcceptContractOfferDocument, options);
      }
export type AcceptContractOfferMutationHookResult = ReturnType<typeof useAcceptContractOfferMutation>;
export type AcceptContractOfferMutationResult = Apollo.MutationResult<AcceptContractOfferMutation>;
export type AcceptContractOfferMutationOptions = Apollo.BaseMutationOptions<AcceptContractOfferMutation, AcceptContractOfferMutationVariables>;